import React from "react";
import LegalPage from "@/components/legal/LegalPage";
import { cookiesContent } from "@/content/legal/cookies";

export default function Cookies() {
  return (
    <LegalPage
      titleKey="public.cookies.title"
      updatedKey="public.lastUpdated"
      metaDescriptionKey="public.cookies.meta"
      sectionsByLang={cookiesContent}
      testId="page-cookies"
    />
  );
}
